import React from "react";
import { CircularProgress, Box } from "@mui/material";

export default function SpinNormal() {
  return (
    <Box
      sx={{
        height: 200,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress />
    </Box>
  );
}
